import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AlloxApiStatus, ALLOX_ROLE_KEY } from '../constants/allox-constant';
import { AlloxApiResponse } from '../models/allox-api-response.model';
import { Router } from '@angular/router';
import { AlloxApiError } from '../models';
import { EnvironmentService } from '../services';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router,
    private environmentService: EnvironmentService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.startsWith(this.environmentService.API_DOMAIN)) {
      // AccessRoleを取得している場合は付与してリクエスト
      let setHeaders = {};
      if (this.authService.accessRole) {
        setHeaders = { [ALLOX_ROLE_KEY]: this.authService.accessRole };
      }
      // リクエストのCloneを作成
      request = request.clone({ setHeaders });
      return next.handle(request).pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            return this.validateError(event.body);
          }
        }),
      );
    }
    return next.handle(request);
  }

  private validateError(body: AlloxApiResponse<{}>) {
    if (body.status !== AlloxApiStatus.SUCCESS) {
      throw new AlloxApiError(body.status, body.error_code, body.msg, body.response);
    }
  }
}
